










import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { pickBy } from 'lodash'
import ConceptAssetImage from './ConceptAssetImage.vue'
import ConceptAssetLink from './ConceptAssetLink.vue'
import RadioButtonGroup from './RadioButtonGroup.vue'
import * as db from '@shared/types/database'

const emptyLinkAsset = (): db.Prototype => ({
  asset_type: 'url',
  title: '',
  url: ''
})

type ConceptType = 'image' | 'link'

@Component({
  components: {
    ConceptAssetImage,
    ConceptAssetLink,
    RadioButtonGroup
  }
})
export default class ConceptAsset extends Vue {
  @Prop({ default: null }) readonly asset!: db.Prototype | null
  @Prop({ default: 'image' }) readonly defaultType!: ConceptType
  @Prop({ default: true }) readonly editable!: boolean
  @Prop({ default: true }) readonly typeSwitchable!: boolean
  @Prop({ default: () => ({}) }) readonly sharedAssets!: Record<string, db.Prototype>

  type: ConceptType = this.defaultType
  imageAsset: Partial<db.Prototype> = {}
  linkAsset: Partial<db.Prototype> = {}

  get buttons () {
    return [
      { title: 'Image', value: 'image' },
      { title: 'Link', value: 'link' }
    ]
  }

  get sharedImages () {
    return pickBy(this.sharedAssets, (value, key) => {
      return this.isImage(value)
    })
  }

  get sharedLinks () {
    return pickBy(this.sharedAssets, (value, key) => {
      return !this.isImage(value)
    })
  }

  @Watch('asset', { immediate: true, deep: true })
  assetUpdated (newVal: Record<string, db.Prototype>, oldVal?: Record<string, db.Prototype>) {
    let key = new Date().getTime()
    let newType = this.defaultType
    let newImageAsset: Record<string, db.Prototype> = {}
    let newLinkAsset: Record<string, db.Prototype> = {}
    newLinkAsset[key++] = emptyLinkAsset()
    if (newVal && Object.keys(newVal).length > 0) {
      var assetKey = Object.keys(newVal)[0]
      var asset = newVal[assetKey]
      switch (asset.asset_type) {
        case '':
        case 'clientupload':
          newType = 'image'
          newImageAsset = newVal
          break
        case 'url':
        case 'desktop':
        case 'mobile':
        case 'document':
          newType = 'link'
          newLinkAsset = newVal
          break
        default:
          console.error(`Unsupported concept asset type: ${asset.asset_type}`)
          break
      }
    }
    this.type = newType
    this.$set(this, 'imageAsset', newImageAsset)
    this.$set(this, 'linkAsset', newLinkAsset)
  }

  isImage (asset: db.Prototype) {
    return ['jpg', 'jpeg', 'gif', 'png', 'tiff'].some(ext => {
      return asset.url && asset.url.slice(ext.length * -1) === ext
    })
  }

  changeType (type: ConceptType) {
    this.type = type
    var asset = this.assetForType(type)
    this.$emit('update-concept-assets', asset)
  }

  assetForType (type: ConceptType) {
    switch (type) {
      case 'image':
        return this.imageAsset
      case 'link':
        return this.linkAsset
      default:
        return {}
    }
  }

  updateImage (asset: Record<string, db.Prototype>) {
    this.imageAsset = asset
    this.$emit('update-concept-assets', asset)
  }

  updateLink (asset: Record<string, db.Prototype>) {
    this.linkAsset = asset
    this.$emit('update-concept-assets', asset)
  }
}
